import React, { Component } from 'react';
import { Modal, Input, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input;

class SetRemark extends Component {
    state = {
        visible: false,
        loading: false,
        catalogId: '',
        pathName: '',
        remark: '',
    }

    show = (catalogId, remark, pathName) => {
        this.setState({
            catalogId,
            visible: true,
            remark,
            pathName,
        });
    }

    hide = () => {
        this.setState({
            remark: '',
            visible: false,
            loading: false,
        });
    }

    handleChange = (value) => {
        this.setState({ remark: value });
    }

    submit = () => {
        const { catalogId, remark } = this.state;
        if (!remark) {
            return message.warning('请填写备注')
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.invFolder.updateRemarks,
            data: {
                invId: sessionStorage.invId,
                catalogId,
                remark,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.queryRemarks();
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, remark, pathName } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={'设置备注'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                width="470px"
            >
                <div className="modal-content" style={{ padding: '20px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div style={{ marginLeft: 40 }}>{pathName}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{width: '40%'}}>{asterisk}备注：</div>
                            <div className="item-right" style={{width: '60%'}}>
                                <TextArea
                                    rows={5}
                                    style={{ width: 180 }}
                                    placeholder="请输入"
                                    value={remark}
                                    onChange={e => this.handleChange(e.target.value)}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default SetRemark;


// WEBPACK FOOTER //
// ./src/components/fileManagement/projectFile/SetRemark.js